// extracted by mini-css-extract-plugin
export default {"Banner4":"banner4_Banner4__nPkLX","img":"banner4_img__iSyiI","icon":"banner4_icon__UShJq","info":"banner4_info__sA+FH","btn":"banner4_btn__b2rC5"};